import React, { useEffect, useState } from 'react';
import "./NewContentItem.css"
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import { compactNumber } from '@/utils/globals/curency-utils';
import { useAuth, useCampaigns, useContentItems } from "@/modules";
import { CampaignPaymentMethod } from "@/data/types";
import NewContentListItem from "@/react_app/NewLatestItems/NewContentListItem/NewContentListItem";
import { calculateCpiRate } from "@/utils/globals/cpi-rate";
import { getRegion } from '@/utils/campaign-utils';

const FavoriteIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
      <path d="M0.5 3C0.5 1.61929 1.61929 0.5 3 0.5H37C38.3807 0.5 39.5 1.61929 39.5 3V37C39.5 38.3807 38.3807 39.5 37 39.5H3C1.61929 39.5 0.5 38.3807 0.5 37V3Z" fill="#130A23" stroke="white"/>
      {/* eslint-disable-next-line max-len,vue/max-len */}
      <path d="M20.2538 26.3293L20 26.1794L19.746 26.3289L13.9261 29.7527L13.9252 29.7532C13.213 30.1742 12.4053 29.5396 12.5765 28.8204L14.1191 22.3564L14.1905 22.0573L13.9557 21.8586L8.80904 17.5035L8.80886 17.5033C8.22438 17.0092 8.51751 16.0496 9.32413 15.987L9.32413 15.987L9.32672 15.9868L16.1002 15.4252L16.3981 15.4005L16.5174 15.1264L19.1678 9.0319L19.1687 9.02993C19.4721 8.32401 20.5269 8.32401 20.8303 9.02993L20.831 9.03152L23.4815 15.1397L23.6006 15.4142L23.8988 15.4389L30.6723 16.0005L30.6749 16.0007C31.4815 16.0633 31.7746 17.0229 31.1901 17.517L31.1899 17.5172L26.0433 21.8723L25.8085 22.071L25.8799 22.3701L27.4224 28.8341C27.5937 29.5533 26.786 30.1879 26.0737 29.7669L26.0736 29.7669L20.2538 26.3293Z" fill="#130A23" stroke="white"/>
    </svg>
  )
}

const AndroidIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none" style={{ marginRight: '7px' }}>
      {/* eslint-disable-next-line max-len,vue/max-len */}
      <path d="M0.656134 2.91108C0.29378 2.91093 8.94037e-05 3.16013 0 3.46662L0.000447029 5.79257C0.000388266 5.86556 0.0173258 5.93783 0.0502912 6.00527C0.0832566 6.0727 0.131603 6.13398 0.192566 6.18559C0.253529 6.2372 0.325913 6.27813 0.405578 6.30604C0.485244 6.33395 0.570628 6.3483 0.656849 6.34826C0.743058 6.34834 0.828439 6.33402 0.9081 6.30612C0.987761 6.27823 1.06014 6.2373 1.12108 6.18568C1.18202 6.13407 1.23033 6.07279 1.26325 6.00534C1.29616 5.9379 1.31303 5.86562 1.31289 5.79265V3.46631C1.3127 3.31899 1.24342 3.17775 1.12027 3.07364C0.997126 2.96953 0.830185 2.91106 0.656134 2.91108ZM5.94812 0.822293L6.40613 0.11435C6.4178 0.0963908 6.42058 0.0752485 6.41386 0.0555584C6.40714 0.0358683 6.39146 0.0192374 6.37028 0.00931236C6.34905 -0.000404796 6.32415 -0.00261992 6.301 0.00315051C6.27785 0.00892095 6.25834 0.0222083 6.24672 0.0401122L5.78406 0.755471C5.3948 0.608813 4.95913 0.526629 4.49817 0.527008C4.03845 0.526629 3.60297 0.608585 3.21531 0.754412L2.75211 0.040869C2.74646 0.0319623 2.73877 0.0240938 2.7295 0.0177193C2.72023 0.0113448 2.70955 0.00659105 2.69809 0.00373339C2.68663 0.000875734 2.67462 -2.90219e-05 2.66274 0.00107152C2.65087 0.00217206 2.63937 0.00525604 2.62891 0.0101448C2.61836 0.014921 2.60903 0.0214314 2.60148 0.0292949C2.59393 0.0371585 2.58831 0.0462173 2.58495 0.0559415C2.58159 0.0656657 2.58055 0.0758601 2.5819 0.0859281C2.58324 0.095996 2.58695 0.105736 2.5928 0.114577L3.05099 0.822066C2.15069 1.21505 1.54239 1.96348 1.54293 2.82277L7.45412 2.82217C7.45439 1.96317 6.84716 1.21626 5.94812 0.822293ZM3.15371 1.91633C3.08797 1.9163 3.02494 1.89417 2.97848 1.8548C2.93202 1.81543 2.90594 1.76205 2.90598 1.70641C2.90601 1.65076 2.93216 1.59741 2.97867 1.55808C3.02518 1.51876 3.08824 1.49668 3.15398 1.49671C3.21973 1.49681 3.28275 1.51896 3.32925 1.5583C3.37575 1.59765 3.40194 1.65098 3.40208 1.70664C3.40198 1.76232 3.37577 1.81569 3.32919 1.85501C3.28262 1.89433 3.2195 1.91639 3.15371 1.91633ZM5.84539 1.91588C5.81285 1.9159 5.78062 1.91049 5.75054 1.89996C5.72047 1.88943 5.69315 1.87398 5.67013 1.85451C5.64711 1.83503 5.62886 1.81191 5.61641 1.78646C5.60395 1.76101 5.59755 1.73373 5.59756 1.70618C5.59792 1.65058 5.62413 1.59734 5.67054 1.55799C5.71694 1.51864 5.7798 1.49635 5.84548 1.49595C5.91111 1.49641 5.97388 1.51874 6.02019 1.55811C6.06649 1.59748 6.0926 1.6507 6.09286 1.70626C6.0929 1.73378 6.08652 1.76104 6.0741 1.78648C6.06168 1.81191 6.04345 1.83502 6.02047 1.85449C5.99748 1.87396 5.97019 1.88941 5.94015 1.89994C5.91011 1.91047 5.87791 1.91589 5.84539 1.91588ZM1.56707 3.01605L1.56805 6.62084C1.56795 6.6987 1.58598 6.7758 1.62114 6.84775C1.65629 6.91969 1.70786 6.98506 1.77291 7.04011C1.83795 7.09516 1.91518 7.1388 2.00018 7.16855C2.08518 7.1983 2.17628 7.21356 2.26826 7.21346L2.74505 7.21361L2.74559 8.44439C2.7455 8.75088 3.03981 9 3.40136 9C3.76398 9 4.05776 8.75065 4.05785 8.44401L4.0575 7.21353L4.9434 7.2133L4.94375 8.44401C4.94375 8.75027 5.23816 8.99992 5.5998 8.99932C5.96242 8.99955 6.25638 8.75019 6.25629 8.44356L6.25584 7.21315L6.73433 7.21285C6.82632 7.21286 6.91741 7.19753 7.0024 7.16775C7.08739 7.13796 7.16462 7.09429 7.22967 7.03924C7.29472 6.98419 7.34633 6.91884 7.38154 6.8469C7.41676 6.77497 7.43489 6.69787 7.4349 6.62001L7.43409 3.01521L1.56707 3.01605ZM8.99955 3.46578C8.99956 3.39284 8.98259 3.3206 8.94961 3.2532C8.91663 3.18581 8.86829 3.12457 8.80734 3.07299C8.74639 3.02142 8.67403 2.98051 8.5944 2.95262C8.51477 2.92472 8.42942 2.91037 8.34324 2.9104C7.98089 2.9101 7.68729 3.15915 7.68729 3.46601L7.68782 5.79212C7.68776 5.86507 7.70469 5.93731 7.73765 6.00471C7.7706 6.07212 7.81893 6.13336 7.87987 6.18495C7.94081 6.23653 8.01316 6.27743 8.09279 6.30533C8.17243 6.33322 8.25777 6.34755 8.34396 6.3475C8.43015 6.34751 8.5155 6.33314 8.59513 6.30522C8.67476 6.27729 8.74711 6.23635 8.80803 6.18475C8.86896 6.13314 8.91727 6.07187 8.95021 6.00445C8.98315 5.93703 9.00007 5.86478 9 5.79182L8.99955 3.46578Z" fill="#A4C439"/>
    </svg>
  )
}

const AppleIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none" style={{ marginRight: '7px' }}>
      {/* eslint-disable-next-line max-len,vue/max-len */}
      <path d="M6.66553 8.63891C6.14862 9.11385 5.58424 9.03886 5.04096 8.81389C4.46603 8.58392 3.93857 8.57392 3.33199 8.81389C2.57245 9.12385 2.17159 9.03386 1.71797 8.63891C-0.856024 6.12423 -0.476253 2.29471 2.44587 2.15473C3.15793 2.18972 3.65374 2.52468 4.07044 2.55468C4.69284 2.43469 5.28887 2.08974 5.95346 2.13473C6.74992 2.19472 7.35123 2.49468 7.74682 3.03462C6.10115 3.9695 6.49147 6.02424 8 6.59917C7.69935 7.34907 7.30903 8.09398 6.66026 8.64391L6.66553 8.63891ZM4.01769 2.12473C3.93857 1.00987 4.89327 0.0899886 5.99038 0C6.14335 1.28984 4.75613 2.24972 4.01769 2.12473Z" fill="white"/>
    </svg>
  )
}

export default function (props) {
  const [campaign, setCampaign] = useState('');
  const [campaignContentItems, setCampaignContentItems] = useState([]);
  const campaigns = useCampaigns();
  const contentItems = useContentItems();
  const user = useAuth();

  useEffect(() => {
    if (props.item && props.item.campaignId) {
      campaigns.manager
        .loadSingle(props.item?.campaignId)
        .then((result) => {
          setCampaign(result);
        });
      contentItems.list
        .loadContentItems(props.item?.campaignId)
        .then((result) => {
          setCampaignContentItems(result);
        })
    }
  }, [props.item]);

  const copyLink = (url) => {
    navigator.clipboard.writeText(url);
  };

  return (
    <div className={'content-item'}>
      <div className={'return'} onClick={() => props.handleReturn()}>
        <i className={'pi pi-arrow-left'} style={{ marginRight: '16px', color: '#9F9EA0', fontSize: '22px' }}/>
        Content Items
      </div>
      <div className={'firstLayer'}>
        <div className={'videoWrapper'}>
          <div className={'video'}>
            <div>
              <iframe
                src={`https://www.youtube.com/embed/${props.item?.vid}`}
                title="YouTube video player"
                className={'videoPlayer'}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              />
              <p className={'title'}>{props.item?.title}</p>
            </div>
            <div className={'info'}>
              <div className={'creatorRow'}>
                <Image src={props.item?.owner.profile.photo} alt={'profile photo'} className={'creatorPhoto'}
                       onClick={() => props.goToCreatorProfile(props.item?.owner.id)}/>
                <div className={'creatorText'}>
                  <p className={'creatorUsername'} onClick={() => props.goToCreatorProfile(props.item?.owner.id)}>{props.item?.owner.name}</p>
                  <p className={'creatorType'}>Influencer</p>
                </div>
              </div>
              <div className={'stats'}>
                <div>
                  <p className={'statsLabel'}>Views</p>
                  <p className={'statsValue'}>{compactNumber(props.item?.statistics?.viewCount)}</p>
                </div>
                <div>
                  <p className={'statsLabel'}>Likes</p>
                  <p className={'statsValue'}>{compactNumber(props.item?.statistics?.likeCount)}</p>
                </div>
                <div>
                  <p className={'statsLabel'}>Comments</p>
                  <p className={'statsValue'}>{compactNumber(props.item?.statistics?.commentCount)}</p>
                </div>
              </div>
            </div>
            <div>
              <p className={'contentUrl'}>Content URL</p>
              <div>
                <a className={'urlLink'} target={'_blank'} href={`https://www.youtube.com/watch?v=${props.item?.vid}`}>
                  {`https://www.youtube.com/watch?v=${props.item?.vid}`}
                </a>
                <i className={'pi pi-copy'} title={'Copy link'} onClick={() => copyLink(`https://www.youtube.com/watch?v=${props.item?.vid}`)}
                   style={{ marginLeft: '11px', color: '#FFF', cursor: 'pointer' }}/>
              </div>
            </div>
          </div>
          <FavoriteIcon/>
        </div>
        {campaign &&
          <div className={'campaignWrapper'}>
            <Image src={campaign?.photo} alt={'campaign photo'} className={'campaignPhoto'} />
            <div className={'campaignContent'}>
              <p className={'campaignName'}>{campaign?.name}</p>
              <div className={'campaignInfoRow'}>
                <div className={'campaignInfo'}>
                  <p className={'campaignInfoLabel'}>Category:</p>
                  <p className={'campaignInfoText'}>{campaign?.targetMarket?.type}</p>
                </div>
                {campaign?.paymentMethod === CampaignPaymentMethod.CPI &&
                  <div className={'campaignInfo'}>
                    <p className={'campaignInfoLabel'}>Campaign CPI:</p>
                    <div>
                      <AndroidIcon /><span className={'campaignInfoText'}>{calculateCpiRate(campaign?.cpi.android.amount, campaign?.appliedFee)} {campaign?.cpi.android.currency}</span><br />
                      <AppleIcon /><span className={'campaignInfoText'}>{calculateCpiRate(campaign?.cpi.ios.amount, campaign?.appliedFee)} {campaign?.cpi.android.currency}</span><br />
                    </div>
                  </div>
                }
                {campaign?.paymentMethod === CampaignPaymentMethod.CPM &&
                  <div className={'campaignInfo'}>
                    <p className={'campaignInfoLabel'}>Campaign CPM:</p>
                    <p className={'campaignInfoText'}>{calculateCpiRate(campaign?.cpm.amount, campaign?.appliedFee)} {campaign?.cpm.currency}</p>
                  </div>
                }
                {campaign?.paymentMethod === CampaignPaymentMethod.CPC &&
                  <div className={'campaignInfo'}>
                    <p className={'campaignInfoLabel'}>Campaign CPC:</p>
                    <p className={'campaignInfoText'}>{calculateCpiRate(campaign?.cpc.amount, campaign?.appliedFee)} {campaign?.cpc.currency}</p>
                  </div>
                }
                <div className={'campaignInfo'}>
                  <p className={'campaignInfoLabel'}>Region:</p>
                  <p className={'campaignInfoText'}>{getRegion(campaign,user.value?.type)}</p>
                </div>
              </div>
            </div>
          </div>}
      </div>
      <div className={'subLayerFirst'}>
        <div className={'subLayerTitleRow'}>
          <p className={'subLayerTitle'}>More Content from this Creator</p>
          <p className={'seeAll'} onClick={() => props.goToCreatorProfile(props.item?.owner.id)}>See All</p>
        </div>
        <div className={'contentItemsGroup'}>
          {props.creator?.contentItems?.filter(item => item.id !== props.item?.id).slice(0, 4).map((item, index) =>
            <div key={index} className={'contentItemWrapper'}>
              <NewContentListItem item={item} creator={props.creator} handleRouting={() => props.goToOtherContentItem(item.id)} />
            </div>)}
        </div>
      </div>
      <div className={'subLayerSecond'}>
        <div className={'subLayerTitleRow'}>
          <p className={'subLayerTitle'}>More Content from this Campaign</p>
          <p className={'seeAll'}>See All</p>
        </div>
        <div className={'contentItemsGroup'}>
          {campaignContentItems?.filter(item => item.id !== props.item?.id).slice(0, 4).map((item, index) =>
            <div key={index} className={'contentItemWrapper'} onClick={() => props.goToOtherContentItem(item.id)}>
              <NewContentListItem item={item} handleRouting={() => props.goToOtherContentItem(item.id)} />
            </div>)}
        </div>
      </div>
    </div>
  )
}
